import { FaCheckCircle } from "react-icons/fa";

const UploadTips = () => {
    return (
        <div className="p-5 mt-20 text-xs text-white bg-black rounded-[10px]">
            <h3 className="mb-3 font-bold">Tips for uploading documents</h3>
            <div className="flex flex-col h-full text-left">
                <div className="relative border-l border-l-light-100 pl-[26px] pb-[25px]">
                    <FaCheckCircle className="absolute text-xl text-white -ml-9" />
                    <p>Use clear, non-blurry photos</p>
                </div>
                <div className="relative border-l border-l-light-100 pl-[26px] pb-[25px]">
                    <FaCheckCircle className="absolute text-xl text-white -ml-9" />
                    <p>Ensure ID numbers are visible</p>
                </div>
                <div className="relative pl-[26px] pb-[25px]">
                    <FaCheckCircle className="absolute text-xl text-white -ml-9" />
                    <p>If applicable, ensure your photos are visible</p>
                </div>
            </div>
        </div>
    );
};

export default UploadTips;

